import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import config from "../../../config";

const changeLanguage = async (vernacularCode) => {
    const { default: i18n } = await import("../../../i18n");
    i18n.changeLanguage(vernacularCode ?? "en");
  };

const useLogin = (apiBaseUrl) => {
    const [searchParams] = useSearchParams();

    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [isFamilyNumbersLoading, setisFamilyNumbersLoading] = useState(false)
    const [isFamilyLoginLoading, setIsFamilyLoginLoading] = useState(false)

    const [familyMemberFormError, setFamilyMemberFormError] = useState(null);
    const [loginErrors, setLoginErrors] = useState(null)

    const navigate = useNavigate();

    const login = async (formData) => {
        const isMobileSite = localStorage.getItem("LOGIN_DEVICE") === "Mobile Site";

        let user = {};
        user.profileid = searchParams.get("profileid");
        user.action = searchParams.get("action");
        user.offlinepack = searchParams.get("offlinepack");

        setIsLoginLoading(true);

        try {
            const response = await fetch(`${config.api.API_URL}/api/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password,
                    loginFrom: localStorage.getItem("LOGIN_DEVICE"),
                    ioskey: "",
                    androidkey: "",
                    webKey: null,
                    device: "no",
                }),
            });

            const data = await response.json();
            const authorization = response.headers.get('authorization');
            localStorage.setItem("accessToken", authorization);

            if(data?.data?.status == "alreadyloggedin" || data.data?.status == "/invalidate") {
                setLoginErrors({loginError:"Other User Logged in"})
                return {
                    error:true,
                    errorMessage:"Other User Logged in"
                }
            }else if(data?.data?.status === "FAILURE"){
                setLoginErrors({loginError:data?.data?.message})

                return {
                    error:true,
                    errorMessage:data?.data?.message
                }
            }

            if (data.data?.selectedversion === "V3") {
                localStorage.setItem("isV3User", true);

                const cmsResponse = await fetch(`${config.api.chat_api}/api/login`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        email: formData.email,
                        password: formData.password,
                        remember_me: formData.remember,
                        ...(isMobileSite && { device: "Mobile Site" }),
                    }),
                });

                const cmsData = await cmsResponse.json();
                localStorage.setItem("INTERNAL_LOGIN", String(cmsData?.access_token) ?? "OLD");
                localStorage.setItem("INTERNAL_LOGIN_ID", String(cmsData?.id) ?? "");

                localStorage.setItem("IS_LOGGED_IN", true);
                localStorage.setItem("LOGIN_NAME", data.data.userName ?? "");
                localStorage.setItem("LOGIN_EMAIL", data.data.userName ?? "");
                localStorage.setItem("LOGIN_ID", data.data.userId);
                localStorage.removeItem("profiledot");
                localStorage.setItem("loginCheckForRquest", 'loginCheckForReq');

                // i18n.changeLanguage(data.data?.vernacularCode ?? "en");
                changeLanguage(data.data?.vernacularCode ?? "en")
                localStorage.setItem("vernacularCode", data.data.vernacularCode ?? "en");

                if (data.data?.paymentToken) {
                    window.location.href = data.data?.paymentToken;
                } else if (data.data.nextPage === "Redirect") {
                    window.location.href = "https://" + data.data.redirect;
                } else if (data.data.nextPage === "phoneNumberEdit") {
                    localStorage.setItem("phoneNumberEdit", true);
                    // navigate(`${RouteHelper.getEditProfileUrl(EditProfileMenu[5].urlPath)}`);
                    navigate(data.data?.selectedversion === "V3" ? "/manage/new/settings":"/manage/settings")
                } else if (user.profileid && user.action === "view") {
                    if (data.data?.selectedversion === "V3") {
                        navigate("/new/match-conversations", {
                            state: {
                                isFrom: "login",
                                id: user.profileid,
                                isFromChat: false,
                                from: "search",
                            },
                        });
                    } 
                } else {
                    localStorage.setItem("LOGIN_CURRENT_PAGE", `/${data.data.nextPage}`);
                    navigate(`/${data.data.nextPage}`);
                }
            }
        } catch (error) {
            console.error("Login error:", error);
        } finally {
            setIsLoginLoading(false);
        }
    };

    const getFamilyNumbers = async (mobilenumber) => {
        try {
            setisFamilyNumbersLoading(true)
            const response = await fetch(
                `${config.api.API_URL}/api/getfamilyloginprofilesv3?mobilenumber=${mobilenumber}`,
            );
            const data = await response.json();
            setisFamilyNumbersLoading(false)

            if (response.status === 200) {
                if (data.status === "Success") {
                    if (data.data.status == "FAILURE") {
                        return {
                            error: true,
                            errorMessage: data?.data?.message ?? "Please enter verified mobile number.",
                            data: null,
                        }
                    }
                    else if (data?.data?.familyMemberDetails.every(member => member.familynumber == "N")) {
                        return {
                            error: true,
                            errorMessage: "Please enter a registered family number",
                            data: null,
                        }
                    }
                    else {
                        return {
                            error: false,
                            errorMessage: "",
                            data: data.data.familyMemberDetails
                        }
                    }
                }
            } else if (response.status === 401) {
            } else {
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const validateFamilyForm = (formData) => {
        const errors = {};

        if (!formData.member) {
            errors.member = "Please select member";
        }

        if (!formData.password) {
            errors.password = "Enter the password associated with the profile holder!";
        }

        if (Object.keys(errors).length > 0) {
            setFamilyMemberFormError(errors);
            return false;
        } else {
            setFamilyMemberFormError(null);
        }

        return true;
    };

    const validateLoginForm = (formData) => {
        const errors = {};

        if (!formData.email) {
            errors.email = "Please Enter Email / Mobile Number";
        }

        if (!formData.password) {
            errors.password = "Please Enter Password";
        }

        if (Object.keys(errors).length > 0) {
            setLoginErrors(errors)
            return false;
        }
        return true;
    };

    const familyLogin = async (mobileNumber, memberId, password) => {
        try {
            const isMobileSite = localStorage.getItem("LOGIN_DEVICE") === "Mobile Site";

            setIsFamilyLoginLoading(true)
            let loginRequest = {
                email: mobileNumber,
                password: password,
                loginFrom: localStorage.getItem(
                    "LOGIN_DEVICE"
                ),
                ioskey: "",
                androidkey: "",
                profileid: memberId,
            };

            let response = await fetch(
                `${config.api.API_URL}/api/familyloginv3`,
                {
                    method:"POST",
                    body:JSON.stringify(loginRequest),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();


            if (data.data.status == 'FAILURE') {
                return {
                    error: true,
                    errorMessage: data.data.popup
                }
            }
            if (data.status === "Success") {
                if (data.data.status === "SUCCESS") {

                    const token = response?.headers?.['authorization']; // Extract token

                    localStorage.setItem("accessToken", token);

                    localStorage.setItem(
                        "LOGIN_FROM",
                        new URL(window.location.href).pathname +
                        new URL(window.location.href).search
                    );
                    localStorage.setItem(
                        "SHOW_LOADER",
                        true
                    );

                    localStorage.setItem(
                        "IS_LOGGED_IN",
                        true
                    ); //is loggedin
                    localStorage.setItem(
                        "LOGIN_NAME",
                        data.data.userName ?? ""
                    ); //username
                    localStorage.setItem(
                        "LOGIN_EMAIL",
                        data.data.userName ?? ""
                    );
                    localStorage.setItem(
                        "LOGIN_ID",
                        data.data.userId
                    ); //userid
                    localStorage.setItem(
                        "familyLoginId",
                        data.data.familyLoginId
                    ); //family login id
                    localStorage.setItem(
                        "familyLoginMobileNumber",
                        mobileNumber
                    );

                    //for vernacular
                    // i18n.changeLanguage(data.data?.vernacularCode ?? "en")
                    changeLanguage(data.data?.vernacularCode ?? "en")
                    localStorage.setItem("vernacularCode", data.data.vernacularCode ?? "en")

                    if (data.data?.selectedversion == "V3") {
                        localStorage.setItem("isV3User", true)
                        // const cms_response = await CMS_Login({
                        //   email: data?.data?.userName,
                        //   password: loginRequest.password,
                        // })
                        const cmsResponse = await fetch(`${config.api.chat_api}/api/loginFamilyCode`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                mobile_number: loginRequest.email,
                                password: loginRequest.password,
                                profile_id: loginRequest.profileid,
                                ...(isMobileSite && { device: "Mobile Site" }),
                            }),
                        });

                        const cms_data = await cmsResponse.json();



                        setIsFamilyLoginLoading(true)

                        if (cms_data) {
                            localStorage.setItem(
                                "INTERNAL_LOGIN",
                                String(cms_data?.access_token) ?? "OLD"
                            );
                            localStorage.setItem(
                                "INTERNAL_LOGIN_ID",
                                String(cms_data?.id) ?? ""
                            );
                        }
                    }

                    if (data.data.nextPage == "Redirect") {
                        // history(`${data.data.redirect}`)
                        window.location.href = "https://" + data.data.redirect;
                    } else if (data.data.nextPage === "phoneNumberEdit") {
                        localStorage.setItem("phoneNumberEdit", true);
                        // navigate(
                        //     `${RouteHelper.getEditProfileUrl(EditProfileMenu[5].urlPath)}`
                        // );
                        navigate(data.data?.selectedversion === "V3" ? "/manage/new/settings":"/manage/settings")
                    } else {
                        localStorage.setItem(
                            "LOGIN_CURRENT_PAGE",
                            `/${data.data.nextPage}`
                        );
                        // history(`/match-lite`)
                        navigate(`/${data.data.nextPage}`);
                    }
                } else {
                    // localStorage.setItem(Constant.loginLocalStorageKeys.showLoader,true)
                    setIsFamilyLoginLoading(true)
                    setFamilyMemberFormError({password:data?.data?.message})
                    return {
                        error: true,
                        errorMessage: response?.data?.data?.message,
                    }
                }
            }
        } catch (error) {
            console.error("Error during login API call:", error);
        }
    };

    return {
        login,
        familyLogin,
        
        isLoginLoading,
        isFamilyNumbersLoading,
        isFamilyLoginLoading,

        getFamilyNumbers,
        
        validateLoginForm,
        validateFamilyForm,
        
        loginErrors,
        familyMemberFormError,

        setLoginErrors

    };
};

export default useLogin;